import React, { useEffect, useState } from "react";
import "../../Assets/Css/ShareHolders.scss";
import { Link, useNavigate } from "react-router-dom";
import UserAvatar from "react-user-avatar";
import { BiPhoneCall } from "react-icons/bi";
import { HiOutlineMail } from "react-icons/hi";
import { connect } from "react-redux";
import { getShareholders } from "../../Services/Shareholders/action";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";

const ShareHolders = (props) => {
  const navigate = useNavigate();
  let path = "/shareholder/add";
  const [shareholderData, setShareholderData] = useState([]);
  const [unassignedAmount, setUnassignedAmount] = useState(0);
  let unsignedAmount = 0;
  let assignedAmount = 0;

  useEffect(() => {
    fetchShareHolderData();
  }, []);

  useEffect(() => {
    console.log('heryyyyysdhfjksdhjkfshdfkjh')
    setTheData();
  }, [props.shareholders]);

  const fetchShareHolderData = async () => {
    try {
      await props.getShareholders();
      setTheData();
    } catch (error) {
      toast.error(error);
    }
  };
  const setTheData = async () => {
    try {
      // alert('ehhh')
      console.log(props, ' <== setting up...')
        ((await props.shareholders) &&
          setShareholderData(await props.shareholders));
      props?.shareholders?.forEach((sh) => {
        assignedAmount += parseFloat(sh?.balance);
        // if (parseFloat(sh?.balance) > 0) {
        // }
      });

      setUnassignedAmount(parseFloat((parseFloat(totalUnAssigned)).toFixed(2)));
    } catch (error) {
      toast.error(error);
    }
  };

  const handleAddClick = () => {
    navigate(path);
  };

  const handleShareholderGroup = (id) => {
    navigate(`/shareholder/group`);
  }

  return (
      <div className="main-shareholder">
        <div className="page-title">
          <h4>Share Holders</h4>
          <div className="button-group">
            <div className="grp-btn" style={{ marginLeft: "auto" }}>
              <button
                className="custom-btn"
                disabled={props.loading}
                onClick={handleShareholderGroup}
              >
                {props.loading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    className="custom-spinner"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  "Share Holder Groups"
                )}
              </button>
            </div>
            <div className="edit-btn">
              <button
                className="custom-btn"
                disabled={props.loading}
                onClick={handleAddClick}
              >
                {props.loading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    className="custom-spinner"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  "Add"
                )}
              </button>
            </div>
          </div>
        </div>
        <div className="content-part">
          {props.loading ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            </div>
          ) : (
            <div className="row custom-row">
              {shareholderData
                ? shareholderData?.map((sholder, index) => {
                  let data = { shId: sholder?.id };
                  return sholder?.is_category !== true ? (
                    <div
                      key={sholder?.id}
                      className="col-xl-4 col-lg-6 custom-col"
                    >
                      <div className="shareholder-card">
                        <div className="shareholder-image-block">
                          <UserAvatar
                            size="100"
                            src={""}
                            name={sholder?.name || "-"}
                          />
                        </div>
                        <div className="shareholder-content-block">
                          <h6 className="sh-name">
                            {sholder?.name || "unknown"}
                          </h6>
                          <h6 className="sh-role">
                            {sholder?.role?.name || "-"}
                          </h6>
                        </div>
                        <div className="shareholder-balance-block">
                          <h6 className="sh-balance">
                            ₹{sholder?.balance || "0"}
                          </h6>
                        </div>
                        <div className="shareholder-contact-block">
                          <div className="contact-mobile">
                            <div className="timeline">
                              <span className="call-icon">
                                <BiPhoneCall />
                              </span>
                              <span className="line"></span>
                            </div>
                            <h6 className="mobile-value">
                              {sholder?.mobile}
                            </h6>
                          </div>
                          <div className="contact-email">
                            <span className="email-icon">
                              <HiOutlineMail />
                            </span>
                            <h6 className="email-value">{sholder?.email}</h6>
                          </div>
                        </div>
                        <div className="action-block">
                          <Link to="/shareholder/view" state={{ data: data }}>
                            <button className="custom-btn">View</button>
                          </Link>
                          <Link to="/shareholder/edit" state={{ data: data }}>
                            <button className="custom-btn">Edit</button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  ) : null;
                })
                : "No Records"}
              {/* <div className="col-xl-4 col-lg-6 custom-col">
                <div className="shareholder-card">
                  <div className="shareholder-image-block">
                    <UserAvatar size="100" src={""} name={"Unallocated"} />
                  </div>
                  <div className="shareholder-content-block">
                    <h6 className="sh-name">Unassigned</h6>
                  </div>
                  <div className="shareholder-balance-block">
                    <h6 className="sh-balance">₹{(props.totalUnAssigned || 0).toFixed(2)}</h6>
                  </div>
                </div>
              </div> */}
            </div>
          )}
        </div>
      </div>
  );
};

export const mapStateToProps = (state) => {
  return {
    shareholders: state.shareholdersReducer.shareholders.rows,
    count: state.shareholdersReducer.shareholders.count,
    totalBalance: state.shareholdersReducer.shareholders.totalBalance,
    totalUnAssigned: state.shareholdersReducer.shareholders.totalUnAssigned,
    loading: state.shareholdersReducer.loading,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    getShareholders: (params) => {
      dispatch(getShareholders(params));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareHolders);
